/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcceptInvitationRequest } from '@localstack/types';
import type { CreateInvitationRequest } from '@localstack/types';
import type { CreateInvitationResponse } from '@localstack/types';
import type { GetInvitationResponse } from '@localstack/types';
import type { InvitationCoordinationResult } from '@localstack/types';
import type { ResendInvitationResponse } from '@localstack/types';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InvitationService {
  /**
   * @param invitationToken
   * @param requestBody
   * @returns any Invitation accepted successfully, no content returned.
   * @throws ApiError
   */
  public static acceptInvitation(invitationToken: any, requestBody?: AcceptInvitationRequest): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/organizations/my/invitations/{invitation_token}/accept',
      path: {
        invitation_token: invitationToken,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param invitationToken
   * @returns InvitationCoordinationResult
   * @throws ApiError
   */
  public static coordinateInvitation(invitationToken: any): CancelablePromise<InvitationCoordinationResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/organizations/my/invitations/{invitation_token}/coordinate',
      path: {
        invitation_token: invitationToken,
      },
    });
  }

  /**
   * @param requestBody
   * @returns CreateInvitationResponse
   * @throws ApiError
   */
  public static createInvitation(requestBody?: CreateInvitationRequest): CancelablePromise<CreateInvitationResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/organizations/my/invitations/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns GetInvitationResponse
   * @throws ApiError
   */
  public static listInvitations(): CancelablePromise<Array<GetInvitationResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/organizations/my/invitations/',
    });
  }

  /**
   * @param invitationId
   * @returns any Invitation successfully deleted, no content returned.
   * @throws ApiError
   */
  public static deleteInvitation(invitationId: any): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/organizations/my/invitations/{invitation_id}',
      path: {
        invitation_id: invitationId,
      },
    });
  }

  /**
   * @param invitationId
   * @returns ResendInvitationResponse
   * @throws ApiError
   */
  public static resendInvitation(invitationId: any): CancelablePromise<ResendInvitationResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/organizations/my/invitations/{invitation_id}/resend',
      path: {
        invitation_id: invitationId,
      },
    });
  }

  /**
   * @param orgId
   * @param requestBody
   * @returns CreateInvitationResponse
   * @throws ApiError
   */
  public static adminCreateInvitation(
    orgId: any,
    requestBody?: CreateInvitationRequest,
  ): CancelablePromise<CreateInvitationResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/admin/orgs/{org_id}/invitations/',
      path: {
        org_id: orgId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param orgId
   * @returns GetInvitationResponse
   * @throws ApiError
   */
  public static adminListInvitations(orgId: any): CancelablePromise<Array<GetInvitationResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/admin/orgs/{org_id}/invitations/',
      path: {
        org_id: orgId,
      },
    });
  }

  /**
   * @param orgId
   * @param invitationId
   * @returns any Invitation successfully deleted, no content returned.
   * @throws ApiError
   */
  public static adminDeleteInvitation(orgId: any, invitationId: any): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/admin/orgs/{org_id}/invitations/{invitation_id}',
      path: {
        org_id: orgId,
        invitation_id: invitationId,
      },
    });
  }
}
